import { render } from "./DonationBasketRule.vue?vue&type=template&id=528e1245&scoped=true"
import script from "./DonationBasketRule.vue?vue&type=script&lang=js"
export * from "./DonationBasketRule.vue?vue&type=script&lang=js"

import "./DonationBasketRule.vue?vue&type=style&index=0&id=528e1245&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528e1245"]])

export default __exports__